/**
 * Replace the coma of this number as string into dot.
 * @return {string} The formatted string if it's possible or the given value otherwise
 */
export default function (numberAsString) {
  if (numberAsString && typeof numberAsString === "string") {
    return numberAsString.replace(",", ".");
  }
  return numberAsString;
}